<script setup>

    // Future idea: use Bootstrap accordion for the extra Teilnehmer detail?

    import { ref, watchEffect, computed } from 'vue';
    import { getFromAPI, buildPageFooter, isButtonDisabled, saveFormViaAPI } from '../functionCollection.js';
    import SearchFields from './SearchFields.vue';
    import Swal from 'sweetalert2';
    import axios from 'axios';

    const props = defineProps(['fetchUrl', 'copyUrl', 'userNumber', 'campaigns']);
    const teilnehmerInfo = ref(null);
    // Key = columns to fetch, Value = human readable title
    const columns = new Map([
        ["Rechnungsempfaenger", "Kd-Nummer"],
        ["Teilnehmer", "Teilnehm."],
        ["Name", "Name"],
        ["Vorname", "Vorname"],
        ["Kartennummer", "Kartennr."],
        ["Vertragsbeginn", "Vertragsbeg."],
        ["Vertragsende", "Vertragsen."],
        ["Tarifnummer", "Tarifnr."],
        ["Tarifbezeichnung", "Tarifbez."],
        ["campaign", "Kamp."],
        ["ma_status", "Status (MA)"],
        ["Firmennachzahler", "Firmennach."],
        ["Monatspauschale", "Monatspau."],
        ]);

    const filteredColumns = computed(() => Array.from(columns.entries()).filter(([k]) => k !== 'campaign'));

    const teilnehmerToChange = ref(null);

    // needed for the page footer
    const currentPage = ref(1);
    const maxPageNumber = ref(1);
    const footerPageNumbers = ref(new Array());

    const sortDirection = ref('asc');

    const filtersAsString = ref('');
    const sortBy = ref('Rechnungsempfaenger');
    const receivedFilterParameters = ref([]);
    const filterParameters = [
        { index: "Rechnungsempfaenger", title: "Kundennummer", value: null },
        { index: "Teilnehmer", title: "Teilnehmer-ID", value: null },
        { index: "Name", title: "Nachname", value: null },
        { index: "Vorname", title: "Vorname", value: null },
        { index: "Firmennachzahler", title: "Firmennachzahler", value: null },
        { index: "Tarifnummer", title: "Tarifnummer", value: null },
        { index: "Tarifbezeichnung", title: "Tarifbezeichnung", value: null },
        { index: "Kartennummer", title: "Kartennummer", value: null }
    ];
    const actualCopyUrl = ref('');
    const participantData = ref(
        {
            customerNr: '',
            participantNr: '',
            name: '',
            givenname: '',
            campaign: '',
        }
    );
    // get the Teilnehmer list content from TeilnehmerController@getTable, build page list footer
    watchEffect(async () => {
        const url = getFullUrl(props.fetchUrl, props.userNumber);
        teilnehmerInfo.value = await getFromAPI(url);
        maxPageNumber.value = teilnehmerInfo.value.meta.last_page;
        teilnehmerInfo.value = teilnehmerInfo.value.data;
        footerPageNumbers.value = buildPageFooter(currentPage.value, maxPageNumber.value);
    });

    // complete the URL. the values in the last concat specify which page we want,
    // as well as which columns from Teilneher we need, and how many entries we want per page.
    function getFullUrl(url) {

        url = url.concat('/').concat(`?page=${currentPage.value}&per_page=25&columns=${Array.from(columns.keys()).toString()}&order=${sortDirection.value}`);

        if (filtersAsString.value !== '') {
            url = url.concat('&filter=').concat(filtersAsString.value);
        }
        if (sortBy.value !== '') {
            url = url.concat('&sortBy=').concat(sortBy.value);
        }
        return url;
    }

    function filterSearch(givenFields) {
        receivedFilterParameters.value = [];
        for (let i = 0; i < givenFields.length; i++) {
            if (givenFields[i].value !== null) {
                receivedFilterParameters.value.push(givenFields[i]);
            }

        }
        filtersAsString.value = JSON.stringify(receivedFilterParameters.value);
        getNewPage(1);
    }


    // calls new Teilnehmer info whenever a page change is requested (i.e. a page button is pressed in the footer)
    async function getNewPage(newPage) {


        currentPage.value = newPage;
        if (currentPage.value < 1) {
            currentPage.value = 1;
        }
        teilnehmerInfo.value = await getFromAPI(getFullUrl(props.fetchUrl));
        teilnehmerInfo.value = teilnehmerInfo.value.data;
        footerPageNumbers.value = buildPageFooter(currentPage.value, maxPageNumber.value);
    }

    function sortTable(key){
        if ( sortBy.value == key){
            if(sortDirection.value == "asc"){
                sortDirection.value = "desc";
            } else {
                sortDirection.value = "asc";
            }
        }
       sortBy.value=key;
       getNewPage(1);

    }

    function reloadCurrentPage(){
        getNewPage(1);
    }

    async function copy(customerNr, participantNr, name, givenname, campaign){
        participantData.value.customerNr = customerNr;
        participantData.value.participantNr = participantNr;
        participantData.value.name = name;
        participantData.value.givenname = givenname;
        participantData.value.campaign = campaign;
        actualCopyUrl.value = getCopyUrl(props.copyUrl, customerNr, participantNr);
        const currentModal = document.querySelector('#modalTeilnehmerCopy');
        const modal = new bootstrap.Modal(currentModal);
        modal.show();
    }

    function getCopyUrl(url, customerNr, participantNr) {
        url = url.replace(":customerNumber", customerNr).replace(":participant", participantNr);
        return url;
    }

    const deleteTeilnehmer = async (rechnungsempfaenger, teilnehmer) => {
        const confirmed = await Swal.fire({
            title: 'Teilnehmer löschen?',
            html: `<p>Hinweise: Bevor Sie den Teilnehmer löschen können, müssen Sie diesen in S&B löschen.<br>
                      Sind Sie sicher, dass Sie diesen Teilnehmer löschen möchten?</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ja, löschen',
            cancelButtonText: 'Abbrechen'
        });

        if (confirmed.isConfirmed) {
            try {
                await axios.delete(`/teilnehmer/${rechnungsempfaenger}/${teilnehmer}`);
                Swal.fire('Gelöscht!', 'Der Teilnehmer wurde gelöscht.', 'success');
                reloadCurrentPage();
            } catch (error) {
                Swal.fire('Fehler', 'Teilnehmer konnte nicht gelöscht werden.', 'error');
            }
        }
    };

</script>

<template>
<div>
    <div class="modal fade" id="modalTeilnehmerCopy" tabindex="-1"  aria-hidden="true">
        <div class="modal-dialog" >
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Teilnehmer Kopieren</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
                </div>
                <div class="modal-body">
                    <teilnehmer-copy
                        :copyUrl="actualCopyUrl"
                        :participantData="participantData"
                        :campaigns="props.campaigns"
                        @reloadPage="reloadCurrentPage"
                    >
                    </teilnehmer-copy>
                </div>
            </div>
        </div>
    </div>

    <div class="teilnehmerListDiv">
        <div>
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button type="button" data-bs-toggle="modal" data-bs-target="#createTeilnehmer" class="btn btn-primary">Teilnehmer hinzufügen</button>
            </nav>
        </div>
        <SearchFields
            :fields="filterParameters"
            @filters="filterSearch"
        />


        <div>
            <div class="main-table" v-if="teilnehmerInfo">
                <div class="inner-table teilnehmerList">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <!-- get header names from columns with icon displaying sorting order  -->
                                <th v-for="[key, value] in filteredColumns" :key="key" class="table-head teilnehmerList"
                                    @click="sortTable(key)"
                                    v-bind:style="sortBy==key ? 'background-color:#b2c3df54;' : ''">
                                        {{ value }}
                                        <i v-if="sortBy==key && sortDirection=='asc'" class="fa-solid fa-arrow-down"></i>
                                        <i v-else-if="sortBy==key" class="fa-solid fa-arrow-up"></i>
                                </th>
                                <th></th>
                            </tr>
                        </thead>

                        <!--
                            Generate these dynamically. There's no other way. Go through v-for with any key. Corresponds here to Teilnehmer ID
                            simply because Teilnehmer IDs are also sequential, but not directly related.
                        -->
                        <tbody v-for="teilnehmer of teilnehmerInfo" :key="teilnehmer.id">
                            <tr class="m-datatable__row teilnehmerList">
                                <td>{{ teilnehmer.Rechnungsempfaenger }}</td>
                                <td>{{ teilnehmer.Teilnehmer }}</td>
                                <td>{{ teilnehmer.Name }}</td>
                                <td>{{ teilnehmer.Vorname }}</td>
                                <td>{{ teilnehmer.Kartennummer }}</td>
                                <td>{{ teilnehmer.Vertragsbeginn }}</td>
                                <td>{{ teilnehmer.Vertragsende }}</td>
                                <td>{{ teilnehmer.Tarifnummer }}</td>
                                <td>{{ teilnehmer.Tarifbezeichnung }}</td>
                                <td>{{ teilnehmer.ma_status }}</td>
                                <td>{{ teilnehmer.Firmennachzahler }}</td>
                                <td>{{ teilnehmer.Monatspauschale }}</td>


                                <td>
                                    <div class="buttons">
                                        <a  class="btn btn-primary btn-sm" style="min-width:75.95px"
                                        :href="'teilnehmeredit/' + teilnehmer.Rechnungsempfaenger + '/' + teilnehmer.Teilnehmer"
                                        role="button">
                                            Bearbeiten
                                        </a>
                                    </div>

                                    <div class="buttons">
                                        <a  class="btn btn-primary btn-sm" style="min-width:75.95px; margin-top: 2px;"
                                        @click="copy(teilnehmer.Rechnungsempfaenger, teilnehmer.Teilnehmer, teilnehmer.Name, teilnehmer.Vorname, teilnehmer.campaign)"
                                        role="button">
                                            Kopieren
                                        </a>
                                    </div>

                                    <div class="buttons" style="display: flex; justify-content: center; align-items: center;">
                                    <span :title="teilnehmer.danger ? 'mehrere Teilnehmer mit selben Firmennachzahler vorhanden, bitte korrigieren bevor gelöscht werden kann' : 'Teilnehmer löschen'">
                                        <button
                                        class="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                                        style="min-width:75.95px; margin-top: 2px; padding:7px;"
                                        @click="teilnehmer.danger ? null : deleteTeilnehmer(teilnehmer.Rechnungsempfaenger, teilnehmer.Teilnehmer)"
                                        :class="{ 'disabled-button': teilnehmer.danger }"
                                        >
                                        <i class="fa-solid fa-trash" style="margin: 0 auto;"></i>
                                        </button>
                                    </span>
                                    </div>
                                </td>
                                </tr>
                            <!-- sub table for additional info, deployed by the icon above.
                                while the class is called "dropdown", it is not actually a Bootstrap dropdown, but instead a collapse.
                                "Historisch gewachsen." Changing the name means changing the CSS, a risk I am not willing to take because
                                it might break tons of other things.
                            -->
                            <!-- <tr class="table-dropdown-row collapse"
                                :id="'dropdown' + teilnehmer.Teilnehmer">
                                <div class="table-dropdown"
                                    style="height: 160.2px;">
                                    <tr>
                                        <th>Vertragsbeginn:</th>
                                        <td>{{ teilnehmer.Vertragsbeginn }}</td>
                                    </tr>
                                    <tr>
                                        <th>Vertragsende:</th>
                                        <td>{{ teilnehmer.Vertragsende }}</td>
                                    </tr>
                                    <tr>
                                        <th>Tarifbezeichnung:</th>
                                        <td>{{ teilnehmer.Tarifbezeichnung }}</td>
                                    </tr>
                                    <tr>
                                        <th>Kartennummer:</th>
                                        <td>{{ teilnehmer.Kartennummer }}</td>
                                    </tr>
                                </div>
                            </tr> -->
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- The page selection footer. Each button is disabled under specific conditions, detailed at the corresponding functions. -->
            <div class="table-footer middle">
                <ul class="pagination">
                    <li class="page-item">
                        <button class="page-link" :disabled="isButtonDisabled('start', currentPage, maxPageNumber)" @click="getNewPage(currentPage - 1)">
                            <i class="fas fa-lg fa-caret-left"></i>
                        </button>
                    </li>
                    <li v-for="page in footerPageNumbers" :key="page.id" :class="{ 'active' : page == currentPage }" >
                        <button class="page-link" @click="getNewPage(page);" :disabled="isButtonDisabled(page, currentPage, maxPageNumber)">{{ page }}</button>
                    </li>
                    <li class="page-item">
                        <button class="page-link" @click="getNewPage(currentPage + 1)" :disabled="isButtonDisabled('end', currentPage, maxPageNumber)">
                            <i class="fas fa-lg fa-caret-right"></i>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>
<style scoped>
    .disabled-button {
        pointer-events: none;
        opacity: 0.6;
    }
</style>
